module.exports = __webpack_public_path__ + "static/media/IMG_4329a.64834559.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/roraima/IMG_4329a.JPG
// module id = 116
// module chunks = 0